import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { getAuthoredContent } from '@/util/getAuthoredContent';

import type { FindALocationAuthoredContent } from 'Types/aemui/find-a-location/findaLocation';

type ExperienceType = 'prospect' | 'lifeclinic' | 'work';

const DEFAULT_EXPERIENCE_TYPE: ExperienceType = 'prospect';

const isExperienceType = (value: unknown): value is ExperienceType => {
	return value === 'prospect' || value === 'lifeclinic' || value === 'work';
};

const normalizeExperienceType = (value: unknown): ExperienceType => {
	return isExperienceType(value) ? value : DEFAULT_EXPERIENCE_TYPE;
};

export const useMapStore = defineStore('map', () => {
	const experienceType = ref<ExperienceType>(DEFAULT_EXPERIENCE_TYPE);
	const defaultPhone = ref('');
	const showComingSoon = computed(() => experienceType.value === 'prospect');
	const showFilterPills = computed(() => experienceType.value === 'prospect');

	const setMapState = () => {
		const authoredContent = getAuthoredContent<FindALocationAuthoredContent>(
			'aemuiFindALocationScript'
		);

		experienceType.value = normalizeExperienceType(authoredContent.experienceType);

		if (authoredContent.defaultPhone) {
			defaultPhone.value = authoredContent.defaultPhone;
		}
	};

	return {
		defaultPhone,
		experienceType,
		showComingSoon,
		showFilterPills,

		setMapState
	};
});
